// departmentService.js
import axios from 'axios';
import { toast } from 'react-toastify';
const API_URL = process.env.REACT_APP_BACKEND_URL + '/api/departments';

export const getDepartments = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;
    } catch (error) {
        // Don't show toast for authentication errors (expected during user switching)
        if (error.response?.status !== 401) {
            const message = (
                error.response && error.response.data && error.response.data.message) ||
                error.message || error.toString();
            toast.error(message);
        }
        return []; // Return empty array on error
    }
};

export const createDepartment = async (departmentData) => {
    const response = await axios.post(API_URL, departmentData);
    return response.data;
};

export const deleteDepartment = async (departmentId) => {
    const response = await axios.delete(`${API_URL}/${departmentId}`);
    return response.data;
};

export const updateDepartment = async (departmentId, departmentData) => {
    const response = await axios.put(`${API_URL}/${departmentId}`, departmentData);
    return response.data;
};